import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { cartOperations } from "../../state/ducs/cart";
import { globalOperations } from "../../state/ducs/globalState";

const NewArrivalsCard = (props) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const detailsClickHandler = () => {
    props.setSelectedProductVendorName(props.productObj.vendor_name);
  }

  const addToCartHandler = () => {
    const other_vendor_products = props.cartItems.filter(
      (item) => item.vendor_name !== props.productObj.vendor_name
    );

    if (other_vendor_products.length) {
      alert("You can order single vendor product only at a time");
      return;
    }

    detailsClickHandler();
    props.addToCart(props.productObj);
    props.showAddToCartModal();
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const truncateTitle = (title, maxLength = 40) => {
    return title.length > maxLength ? title.substring(0, maxLength) + "..." : title;
  };

  return (
    <div 
      className="product-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="product-image-container">
        <Link onClick={detailsClickHandler} to={"/productDetails/" + props.productObj.id}>
          {!imageLoaded && (
            <div className="image-placeholder">
              <div className="placeholder-spinner"></div>
            </div>
          )}
           <img
             src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${props.productObj.photo}`}
             className={`product-image ${imageLoaded ? 'loaded' : ''}`}
             alt={props.productObj.name}
             onLoad={() => setImageLoaded(true)}
             onError={(e) => {
               e.target.src = `${process.env.REACT_APP_API_URL}/placeholder/300/300`;
               setImageLoaded(true);
             }}
          />
        </Link>
        
        <div className={`product-overlay ${isHovered ? 'visible' : ''}`}>
          <div className="product-actions">
            <button className="action-btn" title="Add to Wishlist">
              <i className="fa fa-heart"></i>
            </button>
            <button className="action-btn" title="Quick View">
              <i className="fa fa-search"></i>
            </button>
            <button className="action-btn" title="Compare">
              <i className="fa fa-exchange"></i>
            </button>
          </div>
        </div>

        <div className="product-badge">New</div>
      </div>

      <div className="product-info">
        <div className="product-rating">
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="fa fa-star"></i>
            ))}
          </div>
          <span className="rating-text">(4.5)</span>
        </div>

        <h3 className="product-title">
          <Link 
            onClick={detailsClickHandler} 
            to={"/productDetails/" + props.productObj.id}
            title={props.productObj.name}
          >
            {truncateTitle(props.productObj.name)}
          </Link>
        </h3>

        <div className="product-price">
          ৳{numberWithCommas(props.productObj.price)}
        </div>

        <button 
          onClick={addToCartHandler} 
          className="add-to-cart-btn"
        >
          <i className="fa fa-shopping-cart"></i>
          {props.t("addc") || "Add to Cart"}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { 
    cartItems: state.cart,
  };
};

const mapDispatchToProps = {
  addToCart: cartOperations.addToCart,
  showAddToCartModal: globalOperations.showAddToCartModal,
  setSelectedProductVendorName: globalOperations.setSelectedProductVendorName,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewArrivalsCard);